var React = require('react');
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;
var LinkWrapper = require('../../../components/linkWrapper.jsx')(Link);

var NavListItem = createReactClass({
	render: function(){
		return (
			<li className={this.props.type + " body-toggle special-menu-list-item"} id={this.props.cssId}>
			    <LinkWrapper to={ '/education/' + this.props.url} className="inner" action={this.props.title} handler={this.props.clickTracking}>
				    <div className="tit">
				        <h3>{this.props.title}{!this.props.isActive && <span className='subheader'> - <i>Disabled</i></span>}</h3>
				    </div>
			    </LinkWrapper>
			</li>
	    )
	}
});

module.exports = NavListItem;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/navListItem.jsx